$(document).ready(function(){
   var getval = $("select[name='currency_code'] option:selected").attr('getsymbol');
  $(".get-currncy-symbol").text(getval);
  
  $("select[name='currency_code']").on("change", function() {
 var getval = $(this).find('option:selected').attr('getsymbol'); 
   $(".get-currncy-symbol").text(getval);
});
  function updateCurrencySymbol() {
  var getval = $("select[name='currency_code'] option:selected").attr('getsymbol');
  $(".get-currncy-symbol").text(getval);
}
$(".custom-btn").click(function() {
    // Get selected values and trim spaces
    var selectedCountry = $('.country-list option:selected').val().trim();
    var selectedLanguage = $('.language-details option:selected').val().trim();

    // Log selected values for debugging
    console.log('Selected Country:', selectedCountry);
    console.log('Selected Language:', selectedLanguage);

    // Handle language selection
    $('select.thb-language-code.cstm-lang option').each(function() {
        var secondLanguage = $(this).val().trim();
        console.log('Checking Language:', secondLanguage);
        
        if (selectedLanguage == secondLanguage) {
            console.log('Language Matched:', secondLanguage);
            $(this).prop('selected', true);
            // Dispatch native change event
            var changeEvent = new Event('change', { bubbles: true });
            $(this).closest('select')[0].dispatchEvent(changeEvent);
        }
    });

    // Handle currency selection
     $('select.thb-currency-code.cstm-currncy option').each(function() {
         var optionValue = $(this).val().trim();
         console.log('Checking currency option:', optionValue);

         if (optionValue.includes(selectedCountry)) {
             console.log('Matched currency option:', optionValue);
             $(this).prop('selected', true);
            // Dispatch native change event
             var changeEvent = new Event('change', { bubbles: true });
           $(this).closest('select')[0].dispatchEvent(changeEvent);
             return false; // Exit loop after first match
         }
     });
});
  $('#countryy').click(function(){
    $('body').addClass("ship-drawer");
  });
  $('#close-drwr').click(function(){
    $('body').removeClass("ship-drawer");
  });
  })

  function updateCurrencySymbol() {
    const select = document.querySelector('.country-list');
    const symbolSpan = document.querySelector('.get-currncy-symbol');
    const selectedOption = select.options[select.selectedIndex];
    const symbol = selectedOption.getAttribute('getsymbol');
    symbolSpan.textContent = symbol;
  }

  // Run on page load
  // window.onload = updateCurrencySymbol;
  window.addEventListener('load', updateCurrencySymbol);

// Keep the mobile add-to-cart button sticky after the product form is scrolled past,
// including while Related Products is on screen.
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.getElementById("AddToCart");
  if (!addToCartBtn) return;

  const stickyElement = document.querySelector("product-add-to-cart-sticky");
  const form = addToCartBtn.closest("form") || document.getElementById(addToCartBtn.getAttribute("form"));

  const syncStickyCart = () => {
    const formRect = form ? form.getBoundingClientRect() : null;
    const scrolledPastForm = formRect ? formRect.bottom <= 0 : false;
    const stickyVisible = stickyElement && stickyElement.classList.contains("sticky--visible");

    if (scrolledPastForm || stickyVisible) {
      addToCartBtn.classList.add("sticky-cart-mobile");
    } else {
      addToCartBtn.classList.remove("sticky-cart-mobile");
    }
  };

  syncStickyCart();

  if (stickyElement) {
    const observer = new MutationObserver(syncStickyCart);
    observer.observe(stickyElement, { attributes: true, attributeFilter: ["class"] });
  }

  if (form) {
    const formObserver = new IntersectionObserver(syncStickyCart, { threshold: [0, 0.01, 1] });
    formObserver.observe(form);
  }

  document.addEventListener("product-grid:updated", syncStickyCart);
});

document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.querySelector('.sticky-cart-bar-mobile');
  const addToCartContainer = document.querySelector('product-form:not([data-sticky]) .product-add-to-cart-container');

  if (stickyBar && addToCartContainer && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(addToCartContainer);
  } else if (stickyBar) {
    stickyBar.classList.add('is-visible');
  }

  const stickySelect = document.getElementById('StickyVariantSelect');
  const stickyBtn = document.getElementById('StickyAddToCartBtn');
  const mainForm = document.querySelector('product-form:not([data-sticky]) form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  const mainVariantInput = mainForm ? mainForm.querySelector('select[name="id"], input[name="id"]') : null;
  const mainSubmitBtn = mainForm ? mainForm.querySelector('[type="submit"], [name="add"]') : null;
  const variantPicker = document.querySelector('variant-selects:not([data-sticky])');
  const sizePosition = stickySelect ? Number(stickySelect.dataset.sizePosition) : 0;

  function sizeRadios() {
    if (!variantPicker) return [];
    return Array.prototype.slice.call(variantPicker.querySelectorAll('input[type="radio"][name="Size"]'));
  }

  function selectedOptionValues() {
    if (!variantPicker) return [];
    return Array.prototype.slice.call(variantPicker.querySelectorAll('.product-form__input')).map(function (group) {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function variantData() {
    const script = variantPicker ? variantPicker.querySelector('script[type="application/json"]') : null;
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function refreshSizeAvailability() {
    if (!stickySelect || !sizePosition) return;
    const variants = variantData();
    const selected = selectedOptionValues();
    Array.prototype.forEach.call(stickySelect.options, function (option) {
      const available = variants.some(function (variant) {
        if (!variant.available) return false;
        return selected.every(function (value, index) {
          const variantValue = variant['option' + (index + 1)];
          if (index + 1 === sizePosition) return variantValue === option.value;
          if (value == null) return true;
          return variantValue === value;
        });
      });
      option.disabled = !available && option.value !== stickySelect.value;
    });
  }

  function syncSelectFromSize() {
    const checked = sizeRadios().find(function (radio) { return radio.checked; });
    if (checked && stickySelect.value !== checked.value) {
      stickySelect.value = checked.value;
    }
    refreshSizeAvailability();
  }

  if (stickySelect && sizePosition) {
    syncSelectFromSize();

    stickySelect.addEventListener('change', function () {
      const match = sizeRadios().find(function (radio) { return radio.value === stickySelect.value; });
      if (!match || match.checked) return;
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (variantPicker) {
      variantPicker.addEventListener('change', function () {
        syncSelectFromSize();
      });
    }
  } else if (stickySelect && mainVariantInput) {
    stickySelect.addEventListener('change', function () {
      mainVariantInput.value = this.value;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  if (stickyBtn && mainSubmitBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      mainSubmitBtn.click();
    });
  }
});